import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('get', `/api/live_discussions/${liveID}/summary`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/classSummaryLD.js